import { styled } from '@mui/material';

export const StyledContainer = styled('div')`
    ${({ theme }) => `
        margin: ${theme.tggSpacing([4, 6, 0])};
        ${theme.breakpoints.up('mobile')} {
            margin: ${theme.tggSpacing([4, 8, 0])};
        }
    `}
`;

export const StyledPromoCardLayout = styled('div')`
    ${({ theme }) => `
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: repeat(2, 1fr);
        gap: ${theme.tggSpacing(4)};
        max-width: ${theme.tggSpacing(266)};
        align-items: stretch;
        margin-inline: ${theme.tggSpacing('auto')};

        .promoCard {
            display: flex;
            flex-direction: column;
        }

        .promoCardBody {
            flex: 1;
            display: flex;
            flex-direction: column;
        }

        &[data-count='1'] {
            grid-template-columns: 1fr;
        }

        &[data-count='3'] > :first-child,
        &[data-count='5'] > :first-child {
            grid-column: 1 / -1;
        }

        ${theme.breakpoints.up('desktop')} {
            &[data-count='1'] {
                grid-template-columns: 1fr;
            }

            &[data-count='2'],
            &[data-count='4'] {
                grid-template-columns: repeat(2, 1fr);
            }

            &[data-count='3'] {
                grid-template-columns: repeat(3, 1fr);

                & > :first-child {
                    grid-column: auto;
                }
            }

            &[data-count='5'] {
                grid-template-columns: repeat(6, 1fr);

                & > :nth-child(1),
                & > :nth-child(2) {
                    grid-column: span 3;
                }

                & > :nth-child(n + 3) {
                    grid-column: span 2;
                }
            }
        }
    `}
`;
